if (typeof MYdt == "undefined") {
    var MYdt = {}
}
export function showTip(msg, delay) {
    var tip = $("body>.tip_mask");
    console.log(tip);
    if (!(tip[0])) {
        tip = $("<div class='tip_mask'><div id='tip'></div></div>")
        $("body").append(tip);
    }
    clearTimeout(timeout)
    tip.removeClass("hide").find('#tip').html(msg);
    var timeout = setTimeout(function () {
        $(".tip_mask").addClass("hide")
    }, delay || 3000)
}
MYdt.touchStyle = function (obj, hover, fn) {
    var timer = null, move2 = "", this_ = "", timer2 = null;
    $(obj).removeClass(hover);
    if ($(obj).length > 0 && $(obj).parent().hasClass("infolst")) {
        $(obj).unbind()
    }
    $(obj).bind("touchstart", function () {
        this_ = $(this);
        move2 = "";
        timer = setTimeout(function () {
            this_.addClass(hover)
        }, 150)
    });
    $(obj).bind("touchmove", function () {
        move2 = "move";
        clearTimeout(timer);
        $(this).removeClass(hover)
    });
    $(obj).bind("touchend", function () {
        clearTimeout(timer);
        this_ = $(this);
        if (move2 == "move") {
            clearTimeout(timer);
            $(this).removeClass(hover)
        } else {
            $(this).addClass(hover);
            var this_ = $(this);
            timer2 = setTimeout(function () {
                this_.removeClass(hover);
                if (fn) {
                    fn(this_)
                }
            }, 50)
        }
    });
    $(obj).bind("touchcancel", function () {
        clearTimeout(timer2);
        clearTimeout(timer);
        $(this).removeClass(hover)
    })
};
var validate = {
    account: function (notTip) {
        var accounttext = $('input[name="username"]').val();
        if (/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,23}$/.test(accounttext)) {
            return true
        } else {
            if (!notTip) {
                if (accounttext == "") {
                    showTip("账号不能为空！")
                } else {
                    showTip("账号为1-23位字符！")
                }
            }
            return false
        }
        // return account
    }, password: function (notTip) {
        var passwordtext = $('input#password').val();
        var password = false

        if (/^[a-zA-Z0-9_\u4e00-\u9fa5]{6,30}$/.test(passwordtext)) {
            password = true
        } else {
            if (!notTip) {
                if (passwordtext == "") {
                    showTip("密码不能为空！")
                } else {
                    showTip("密码为6-30位字符！")
                }
            }
            password = false
        }
        return password
    }, certain_password: function (showTip) {
        var certainPasswordText = $('input[name="comppsd"]').val();
        var certainPassword = false

        if (/^[a-zA-Z0-9_\u4e00-\u9fa5]{6,30}$/.test(certainPasswordText) && certainPasswordText == $('input[name="psd"]').val()) {
            certainPassword = true
        } else {
            if (certainPasswordText == "") {
                showTip("确认密码不能为空！")
            } else {
                showTip("两次密码不一致！")
            }
            certainPassword = false
        }
        return certainPassword
    },
    valiphone: function (notTip) {
        var valiphoneText = $("input[name='telephone']").val();
        var valiphone = false;
        if (/1\d{10}$/g.test(valiphoneText)) {
            valiphone = true
        } else {
            if (!notTip) {
                if (valiphoneText == "") {
                    showTip("手机号码不能为空")
                } else {
                    showTip("手机号码为11位数字！")
                }
            }
            valiphone = false
        }
        return valiphone
    },
    valicode: function (notTip) {
        var valicodeText = $("input[name='phone_code']").val();
        var valicodeflag = false;
        if (!window.successToken) {
            if (!notTip) {
                showTip("请填写真实的验证码");
            }
            return false;
        }
        if (/^[0-9]{4}$/.test(valicodeText)) {
            valicodeflag = true
        } else {
            if (!notTip) {
                if (valicodeText == "") {
                    showTip("验证码不能为空！")
                } else {
                    showTip("验证码为4位数字！")
                }
            }
            valicodeflag = false
        }
        return valicodeflag
    },
    /**
     * 
     */
    checkedYs: function (notTip) {
        var checked = $("i.icon_xuanzhong").hasClass("checked")
        if (!checked && !notTip) {
            showTip("请仔细阅读服务协议及隐私条款并且选中")
        }
        return checked;
    },//显示提示按钮能不能点击
    checkSubmit(notTip) {
        return !this.account(notTip) || !this.password(notTip) || !this.checkedYs(notTip)
    },
    //显示提示按钮能不能点击
    checkSubmitCode(notTip) {
        return !this.valiphone(notTip) || !this.valicode(notTip) || !this.checkedYs(notTip)
    }
};

export default validate;

(function ($) {
    MYdt.touchStyle(".reg,.zhmm,#login", "green")
})(Zepto);




// WEBPACK FOOTER //
// ./src/assets/js/formvalidate.js